import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  cartItems: [],
  amount: 0,
  total: 0,
  isLoadingCart: false,
  isOnlineCartLoading: false,
  onlineCart: [],
  onlineCartError: null,
};

const cartSlice = createSlice({
  name: "cartProduct",
  initialState,
  reducers: {
    clearCart: (state) => {
      state.cartItems = [];
      state.amount = 0;
      state.total = 0;
    },
    removeItem: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload
      );
      cartSlice.caseReducers.calculateTotals(state);
      toast.error("Produit supprimé");
    },
    updateCartAmount: (state, action) => {
      const cartItem = state.cartItems.find(
        (item) => item.id === action.payload.id
      );
      if (cartItem) {
        cartItem.amount = parseFloat(action.payload.price) || 0;
        cartItem.quantity = parseFloat(action.payload.quantity) || 1;
        cartSlice.caseReducers.calculateTotals(state);
      }
    },
    calculateTotals: (state) => {
      state.amount = state.cartItems.reduce(
        (acc, item) => acc + item.quantity,
        0
      );
      state.total = state.cartItems.reduce(
        (acc, item) => acc + item.quantity * (parseFloat(item.price) || 0),
        0
      );
    },
    addToCart: (state, action) => {

      const quantityToAdd =
        parseFloat(action.payload.quantity ?? action.payload.stock_quantity) || 1;
    
      const existingCartItem = state.cartItems.find(
        (item) => item.id === action.payload.id
      );
    
      if (existingCartItem) {
        existingCartItem.quantity += quantityToAdd;
      } else {
        state.cartItems.push({
          ...action.payload,
          quantity: quantityToAdd,
        });
      }
    
      cartSlice.caseReducers.calculateTotals(state);
      toast.success("Product added to the cart!");
    },
    
    
  },
});

export const {
  clearCart,
  removeItem,
  updateCartAmount,
  calculateTotals,
  addToCart,
} = cartSlice.actions;
export default cartSlice.reducer;
